import { Branch } from '../../Models/branch';

export const ASSIGNEDBRANCHES: Branch[] = [

];
